/**
 * PATH: apps/qa/src/lib/api/checklists.ts
 * PURPOSE: Checklist instances and item instances API
 */

import { api, normaliseList } from './helpers'

export const checklistApi = {
  getInstances: async (params?: { area_id?: string; page?: number; page_size?: number }): Promise<{ results: Record<string, unknown>[]; count: number }> => {
    const response = await api().get('/qa/checklist-instances/', { params })
    return normaliseList(response.data)
  },
  applyTemplate: async (templateId: string, areaIds: string[]) => {
    const r = await api().post('/qa/checklist-instances/apply_template/', { template_id: templateId, area_ids: areaIds })
    return r.data
  },
}

export const itemInstanceApi = {
  getItems: async (params?: { checklist_instance_id?: string; area_id?: string; status?: string; page?: number; page_size?: number }): Promise<{ results: Record<string, unknown>[]; count: number }> => {
    const response = await api().get('/qa/item-instances/', { params })
    return normaliseList(response.data)
  },
  getItem: async (id: string) => { const r = await api().get(`/qa/item-instances/${id}/`); return r.data },
  setStatus: async (id: string, status: string, overrideReason?: string) => {
    const r = await api().post(`/qa/item-instances/${id}/set_status/`, { status, override_reason: overrideReason })
    return r.data
  },
  reorder: async (order: { id: string; sort_order: number }[]) => {
    const r = await api().post('/qa/item-instances/reorder/', { order })
    return r.data
  },
  addItem: async (
    areaId: string,
    fields: Record<string, unknown> = {},
    insertAfterNumber?: string,
  ) => {
    const r = await api().post(`/qa/areas/${areaId}/add-item/`, {
      ...fields,
      ...(insertAfterNumber ? { insert_after_number: insertAfterNumber } : {}),
    })
    return r.data
  },
  updateItem: async (templateItemId: string, fields: Record<string, unknown>) => {
    const r = await api().patch(`/qa/template-items/${templateItemId}/`, fields)
    return r.data
  },
  deleteItem: async (itemInstanceId: string) => {
    const r = await api().delete(`/qa/item-instances/${itemInstanceId}/`)
    return r.data
  },
  raiseChange: async (itemInstanceId: string, kind: 'edit' | 'delete', fields: Record<string, unknown> = {}) => {
    const r = await api().post('/qa/item-change-requests/', { item_instance: itemInstanceId, kind, ...fields })
    return r.data
  },
  approveChange: async (changeId: string, note?: string) => {
    const r = await api().post(`/qa/item-change-requests/${changeId}/approve/`, note ? { note } : {})
    return r.data
  },
  rejectChange: async (changeId: string, note?: string) => {
    const r = await api().post(`/qa/item-change-requests/${changeId}/reject/`, note ? { note } : {})
    return r.data
  },
}
